<template>
    <span v-if="mostrarBtn">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-check-circle-o"></i> Aceitar Condições
                Contratuais</span
            >
        </b-button>
        <b-modal
            v-model="mostrarModal"
            @show="obterCondicoesContratuais()"
            size="lg"
        >
            <div slot="modal-title">
                Solicitação de Consultoria - Aceita as condições contratuais?
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-card bg-variant="dark" text-variant="white">
                        <b-card-text
                            ><div v-html="condicoesContratuais"></div
                        ></b-card-text>
                    </b-card>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="confirmar()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-check-circle-o"></i> Aceitar Condições
                        Contratuais</span
                    >
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            condicoesContratuais: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.condicoesContratuais = null
        },

        obterCondicoesContratuais() {
            this.$store.dispatch('addRequest')
            this.services.obterCondicoesContratuais().then(response => {
                if (response) {
                    if (response.success) {
                        this.condicoesContratuais = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter condições contratuais!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmar() {
            this.$swal({
                title: `Solicitação de Consultoria`,
                html: 'Confirma o ACEITE nas condições contratuais?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aceitar()
                }
            })
        },

        aceitar() {
            this.$store.dispatch('addRequest')
            let aceiteDto = {
                consultoriaId: this.$route.params.consultoriaId
            }
            this.services
                .aceitarCondicoesContratuais(aceiteDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Condições contratuais aceitas com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterConsultoriaAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao processar a solicitação!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-01') &&
                this.consultoria.status ===
                    consultoriaStatus.AGUARDANDO_ACEITE_CONDICOES_CONTRATUAIS
            )
        }
    }
}
</script>
